import { render, staticRenderFns } from "./HistoryHeader.vue?vue&type=template&id=aa2ab56c&scoped=true&"
import script from "./HistoryHeader.vue?vue&type=script&lang=js&"
export * from "./HistoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHeader.vue?vue&type=style&index=0&id=aa2ab56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2ab56c",
  null
  
)

export default component.exports